module.exports = __webpack_public_path__ + "static/media/iconVotCon.1e8e7a1f.svg";